<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Survey Overview
      <div slot="right">
        <b-field>
          <b-select placeholder="Default" expanded v-model="surveyPage">
            <option selected value="products">Products</option>
            <option value="packaging_type">
              Pakaging Type
            </option>
          </b-select>
        </b-field>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <survey-product-list
        v-if="surveyPage == 'products'"
        :customer-id="switchCustomerId"
      />
      <survey-packaging-list
        v-if="surveyPage == 'packaging_type'"
        :customer-id="switchCustomerId"
      />
    </section>
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import SurveyProductList from "@/components/Survey/SurveyProductList.vue";
import SurveyPackagingList from "@/components/Survey/SurveyPackagingList.vue";
import utitlityMixin from "@/mixins/UtilityMixin";
export default {
  name: "SurveyOverview",
  mixins: [utitlityMixin],
  components: { HeroBar, TitleBar, SurveyProductList, SurveyPackagingList },
  data() {
    return {
      surveyPage: "products",
      switchCustomerId: null
    };
  },
  mounted() {
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerViewEnabled =
        switchCustomerData["isSwitchCustomerView"];
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }
    if (this.mappedCustomer && this.mappedCustomer.length > 0) {
      this.switchCustomerId = this.mappedCustomer[0];
    }
    if (!this.switchCustomerId) {
      this.$router.push({ name: "home" });
    }
  },
  computed: {
    editObjectName() {
      return this.editObject || this.getClearFormObject();
    },
    titleStack() {
      return [
        { url: "#", name: "Survey" },
        { url: "/survey/product", name: "Survey Product" }
      ];
    }
  }
};
</script>
